import { render, staticRenderFns } from "./MoveGridBlock.vue?vue&type=template&id=62802074&"
import script from "./MoveGridBlock.vue?vue&type=script&lang=js&"
export * from "./MoveGridBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports